import React, { useCallback } from "react"
import clsx from "clsx"
import Text from "./Text"
import { Draggable } from "react-beautiful-dnd"
import { Box as MuiBox } from "@material-ui/core"
import useStyles from "./styles"

const _BoardCardItem = (props) => {
  const {
    item,
    index,
    fields,
    selected,
    onClick,
    draggableId,
    computedFields,
  } = props

  const classes = useStyles()

  const isDone = item?.status?.progress >= 90 && item?.status?.progress <= 100
  const doneStyle = isDone ? "textSecondary" : "textPrimary"

  const renderContent = useCallback((fieldKey, fieldConfig, computedContent) => {
    if (!fieldConfig || !computedContent) return null

    if (fieldKey === 'title' && computedContent.primary) {
      return (
        <MuiBox display='flex' alignItems='baseline'>
          <MuiBox flexGrow={1}>
            <Text
              className={classes.boardCardItemTitle}
              color={selected ? "textPrimaryContrast" : doneStyle}>
              {computedContent.primary}
            </Text>
          </MuiBox>
          {computedContent.secondary && (
            <Text
              variant="body2"
              color={selected ? "textSecondaryContrast" : "textSecondary"}
              noWrap={true}>
              {computedContent.secondary}
            </Text>
          )}
        </MuiBox>
      )
    }

    if ((fieldKey === 'subtitle' || fieldKey === 'footer') && computedContent.primary) {
      return (
        <MuiBox display='flex' alignItems='center'>
          <MuiBox flexGrow={1}>
            <Text
              variant="body2"
              color={selected ? "textPrimaryContrast" : doneStyle}
              maxLine={3}>
              {computedContent.primary}
            </Text>
          </MuiBox>
          {fieldConfig.secondary && (
            <Text
              variant="body2"
              color={selected ? "textSecondaryContrast" : "textSecondary"}
              noWrap={true}>
              {computedContent.secondary}
            </Text>
          )}
        </MuiBox>
      )
    }

    if (fieldKey === 'body' && Array.isArray(fieldConfig)) {
      return (
        <MuiBox>
          {computedContent.map((content, bodyIndex) => (
            <React.Fragment key={bodyIndex}>
              <Text
                variant="body2"
                maxLine={4}
                color={selected ? "textSecondaryContrast" : "textSecondary"}
              >
                {content}
              </Text>
            </React.Fragment>
          ))}
        </MuiBox>
      )
    }

    return null
  }, [selected, doneStyle, classes.boardCardItemTitle])

  const cardClass = clsx(classes.card, classes.boardCardItem, selected && classes.listItemButtonSelected, classes.pointer)

  const cardInner = (
    <div className={cardClass} onClick={onClick} style={{ minHeight: 120 }}>
      {/* Title Section */}
      {fields.title && renderContent('title', fields.title, computedFields.title)}

      {/* Subtitle Section */}
      {fields.subtitle && renderContent('subtitle', fields.subtitle, computedFields.subtitle)}

      {/* Body Section */}
      {fields.body && renderContent('body', fields.body, computedFields.body)}

      {/* Footer Separator & Section */}
      {fields.footer && <>
        <div className={classes.separatorFooter} />
        {renderContent('footer', fields.footer, computedFields.footer)}
      </>}
    </div>
  )

  if (draggableId) {
    return (
      <Draggable draggableId={draggableId} index={index}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            tabIndex={null}
          >
            {cardInner}
          </div>
        )}
      </Draggable>
    )
  }

  return <div>{cardInner}</div>;
}

export const BoardCardItem = React.memo(_BoardCardItem, (prev, next) => {
  return (
    // prev.item === next.item &&
    // prev.selected === next.selected &&
    // prev.fields === next.fields &&
    // prev.computedFields === next.computedFields
    prev.selected === next.selected &&
    prev.computedFields === next.computedFields &&
    prev.item.uid === next.item.uid &&
    prev.item.status?.progress === next.item.status?.progress
  )
})
